import { render, staticRenderFns } from "./ShowFormRow.vue?vue&type=template&id=53c2577d&"
import script from "./ShowFormRow.vue?vue&type=script&lang=js&"
export * from "./ShowFormRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports